import * as React from 'react'
import { Main } from '@/components/layout/main'
import ModuleCard, { ModuleCardProps } from './components/module-card'
import { useNavigate } from '@tanstack/react-router'

interface ModuleListItem extends Omit<ModuleCardProps, 'active' | 'as'> {
  id: string
}

const modules: ModuleListItem[] = [
	{
		id: '1',
		title: 'International Business Management',
		author: 'Robert Fox',
		imageUrl: 'https://tse2.mm.bing.net/th/id/OIP.Ai9h_6D7ojZdsZnE4_6SDgAAAA?r=0&rs=1&pid=ImgDetMain&o=7&rm=3',
		students: 42,
		tests: 19,
	},
	{
		id: '2',
		title: 'Digital Businesses',
		author: 'Eleanor Pena',
		imageUrl: 'https://tse2.mm.bing.net/th/id/OIP.Ai9h_6D7ojZdsZnE4_6SDgAAAA?r=0&rs=1&pid=ImgDetMain&o=7&rm=3',
		students: 42,
		tests: 19,
	},
	{
		id: '3',
		title: 'Data collection and management',
		author: 'Arlene McCoy',
		imageUrl: 'https://tse2.mm.bing.net/th/id/OIP.Ai9h_6D7ojZdsZnE4_6SDgAAAA?r=0&rs=1&pid=ImgDetMain&o=7&rm=3',
		students: 42,
		tests: 19,
	},
	{
		id: '4',
		title: 'Product Design and Development',
		author: 'Courtney Henry',
		imageUrl: 'https://tse2.mm.bing.net/th/id/OIP.Ai9h_6D7ojZdsZnE4_6SDgAAAA?r=0&rs=1&pid=ImgDetMain&o=7&rm=3',
		students: 42,
		tests: 19,
	},
]

export const ModulesPage: React.FC = () => {
	const [active, setActive] = React.useState(0)
	const navigate = useNavigate()

	return (
		<Main className='pt-4'>
			<div className='flex flex-wrap gap-5'>
				{modules.map((m, i) => (
					<ModuleCard
						key={m.id}
						{...m}
						active={i === active}
						as='button'
						onSelect={() => {
							setActive(i)
							navigate({ to: '/modules/detail/$moduleId', params: { moduleId: m.id } })
						}}
					/>
				))}
			</div>
		</Main>
	)
}

export default ModulesPage
